import React from "react";

const CloseIcon = ({ width = 25, height = 25, color = "#3f3f3f" }) => {
  return (
    <svg
      width={`${width}px`}
      height={`${height}px`}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="m7.757 16.243 8.486-8.486M16.243 16.243 7.757 7.757"
        stroke={color}
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
      />
    </svg>
  );
};

export default CloseIcon;
